import { EstimateRowTypeEnum } from '@enums/EstimateRowType';
import { Estimate } from '@interfaces/Estimate';
import { EstimateRow } from '@interfaces/EstimateRow';
import { TreeNode } from 'primeng/api';
import { TreeNodeData } from '../estimate/treetable/models/tree-node-data.model';

export class EstimateRowModel implements EstimateRow {
  public project = '';
  public level1 = '';
  public level2 = '';
  public department = '';
  public category = '';

  public dateStart = new Date();
  public dateEnd = new Date();

  public notes = '';
  public costFees = 0;
  public billableFees = 0;
  public billableFeesFinal = 0;

  public costExpenses = 0;
  public expenseQuantity = 0;
  public expenseUnitCost = 0;

  public billableExpenses = 0;
  public billableExpensesFinal = 0;
  public totalHours = 0;
  public totalCost = 0;
  public totalBillable = 0;
  public totalBillableFinal = 0;
  public classificationCells: { [key: string]: number } = {};

  public internalFeesQuantity = 0;
  public internalFeesCost = 0;
  public internalFeesBillable = 0;
  public internalFeesBillableFinal = 0;
  public internalFeesCells: { [key: string]: number } = {};

  public constructor(public type: EstimateRowTypeEnum) {}

  public setRow(
    node: TreeNode,
    estimate: Estimate,
    projectLabel: string,
    level1Label = '',
    level2Label = '',
    departmentLabel = '',
    categoryLabel = ''
  ) {
    const nodeData: TreeNodeData = node.data;
    this.project = projectLabel;
    this.level1 = level1Label;
    this.level2 = level2Label;
    this.department = departmentLabel;
    this.category = categoryLabel;
    this.costFees = nodeData.totals.totalHoursCost;
    this.billableFees = nodeData.totals.totalHoursBillable;
    this.billableFeesFinal = nodeData.totals.totalHoursBillableFinal;

    this.expenseQuantity = nodeData.totals.expenseCostQuantity;
    this.expenseUnitCost = nodeData.totals.expenseCostUnitCost;
    this.costExpenses = nodeData.totals.totalExpensesCost;

    this.billableExpenses = nodeData.totals.totalExpensesBillable;
    this.billableExpensesFinal = nodeData.totals.totalExpensesBillableFinal;
    this.totalHours = nodeData.totals.totalHours;
    this.totalCost = nodeData.totals.totalCost;
    this.totalBillable = nodeData.totals.totalBillable;
    this.totalBillableFinal = nodeData.totals.totalBillableFinal;
    this.dateStart = nodeData.startDate;
    this.dateEnd = nodeData.endDate;
    this.notes = nodeData.notes;

    // set a classification cell for each classification-estimate

    const classificationTotals = nodeData.totals.classificationTotals;

    for (const classificationEstimate of estimate.classificationEstimates) {
      if (classificationTotals.hasOwnProperty(classificationEstimate.id)) {
        this.classificationCells[classificationEstimate.classification.code] =
          classificationTotals[classificationEstimate.id];
      } else {
        this.classificationCells[classificationEstimate.id] = 0;
      }
    }

    const internalResourceTotal = nodeData.totals.internalResourceTotals;
    for (const internalResourceEstimate of estimate.internalResourceEstimates) {
      if (internalResourceTotal.hasOwnProperty(internalResourceEstimate.id)) {
        this.internalFeesCells[internalResourceEstimate.internalResource.code] =
          internalResourceTotal[internalResourceEstimate.id];
      } else {
        this.internalFeesCells[internalResourceEstimate.id] = 0;
      }
    }

    this.internalFeesQuantity = nodeData.totals.totalInternalFeesQuantity;
    this.internalFeesCost = nodeData.totals.totalInternalFeesCost;
    this.internalFeesBillable = nodeData.totals.totalInternalFeesBillable;
    this.internalFeesBillableFinal = nodeData.totals.totalInternalFeesBillableFinal;
  }
}
